import { render, staticRenderFns } from "./PricingOrder.vue?vue&type=template&id=27972dcf&scoped=true&"
import script from "./PricingOrder.vue?vue&type=script&lang=js&"
export * from "./PricingOrder.vue?vue&type=script&lang=js&"
import style0 from "./PricingOrder.vue?vue&type=style&index=0&id=27972dcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27972dcf",
  null
  
)

export default component.exports